export const navigationEn = {
  navigation: {
    titlebar: {
      logout: 'Logout',
    },
    general: 'General',
    external: 'Integrated partners',
    apps: 'Apps',
    user: 'User Name',
    home: 'Home',
    sites: {
      root: 'Sites',
    },
    announcements: {
      root: 'Announcements',
    },
    discounts: {
      root: 'Discounts',
    },
    adminPanel: {
      nav: 'Administration',
      userManagement: {
        root: 'Users',
      },
    },
    orders: {
      root: 'Orders',
    },
    menus: {
      root: 'Menus',
      global: 'Global Menus',
      local: 'Local Menus',
      stock: 'Manage Stock',
    },
    libraries: {
      root: 'Libraries',
    },
    reports: {
      root: 'Reports',
      reportingDiagnostics: 'Reporting Diagnostics',
      salesSummary: 'Sales Summary',
      salesDistribution: 'Sales Distribution',
      salesMix: 'Sales Mix',
      refundReport: 'Refunds',
      terminalSales: 'Terminal Sales',
      discounts: 'Discounts',
      salesReading: 'Sales Reading',
    },
    operatorAnalytics: {
      root: 'Operator Analytics',
    },
    scanner: {
      root: 'Barcode Scanner',
    },
    forecasting: {
      root: 'Forecasting',
    },
    logout: {
      root: 'Logout',
    },
    inventory: {
      root: 'Inventory',
      desktop: 'Desktop',
      mobile: 'Mobile',
    },
    labs: {
      root: 'Labs',
    },
    discover: {
      root: 'Discover',
    },
    loyalty: {
      root: 'Loyalty',
      campaigns: 'Campaigns',
      vouchers: 'Vouchers',
      programs: 'Programs',
      segments: 'Segments',
      reporting: 'Reporting',
      settings: 'Settings',
    },
  },
};
